import { z } from 'zod'
import { responseSchema } from '@/core/types/Response.ts'

export const refinanceQuoteSchema = z.object({
  id: z.number(),
  name: z.string(),
  quote: z.string(),
  status: z.enum(['PENDIENTE', 'ATRASADA', 'PAGADA']),
  dueAt: z.string(),
  paymentDate: z.string().nullable(),
  paid: z.string(),
  type: z.enum(['PRODUCT', 'RECUPERATION'])
})
export type RefinanceQuote = z.infer<typeof refinanceQuoteSchema>

export const refinanceQuotesResponseSchema = responseSchema(
  z.object({
    refinancingAmount: z.number(),
    quotes: z.array(refinanceQuoteSchema)
  })
)
export type RefinanceQuotesResponse = z.infer<
  typeof refinanceQuotesResponseSchema
>

export type RefinanceQuotePayload = {
  name: string
  quote: number
  dueAt: string
  status?: 'PENDIENTE' | 'ATRASADA'
}

export type RefinancePayload = {
  quotes: RefinanceQuotePayload[]
}
